import DOMPurify from 'dompurify';
import { Marked } from 'marked';

const markdown = new Marked({
  gfm: true,
  breaks: true,
  renderer: {
    link({ href, title, tokens }) {
      const anchor = document.createElement('a');
      anchor.setAttribute('href', href || '');
      if (title) anchor.setAttribute('title', title);
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer');
      anchor.innerHTML = this.parser.parseInline(tokens);
      return anchor.outerHTML;
    },
    html({ text, block }) {
      const literal = document.createElement('span');
      literal.textContent = block ? text.trimEnd() : text;
      if (!block) return literal.innerHTML;
      return `<p>${literal.innerHTML.replace(/\n/g, '<br>')}</p>\n`;
    },
  },
  tokenizer: {
    del(src) {
      const match = /^~~(?=[^\s~])([\s\S]*?[^\s~])~~(?!~)/.exec(src);
      if (!match) return undefined;
      return { type: 'del', raw: match[0], text: match[1], tokens: this.lexer.inlineTokens(match[1]) };
    },
  },
});

export function renderSupportMarkdown(text) {
  const source = (text || '').trim();
  if (!source) return '';
  return DOMPurify.sanitize(markdown.parse(source), { ADD_ATTR: ['target'] });
}
